import { browserFastApiClient, requireFastApiAccessToken } from "@/core/fastapi";
import {
  extractThoughtsApiService,
  type ExtractThoughtsRequest,
  type ExtractThoughtsResponse,
} from "@/generated/fastapi";

export async function extractThoughts(
  accessToken: string | null | undefined,
  request: ExtractThoughtsRequest,
): Promise<ExtractThoughtsResponse | null | undefined> {
  try {
    const response = await extractThoughtsApiService({
      client: browserFastApiClient,
      body: request,
      auth: requireFastApiAccessToken(accessToken),
    });

    if (response.status === 200) {
      return response.data;
    }

    return response.data;
  } catch {
    return null;
  }
}
